var console = require('console');

var MiddleWareApi = require('./middleware/MiddleWareApi.js');
var ChromeExtensionApi = require('./chrome_extension/chromeExtensionApi.js');

//use export if you want to use this as a dependency
window.IntoitCardRederApiFactory = function(){

	var _middlewareApi = null,
	_appletApi = null,
	_chromeExtensionApi = null;

	

	var rv = {
		//public api
		getMiddlewareApi : function(config){
			if( ! _middlewareApi){
				_middlewareApi = new MiddleWareApi(config);
			}
			return _middlewareApi;
		
		},
		
		getAppletApi : function () {
			
			
			
		},
		
		
		getChromeExtensionApi : function(config) {
			if ( ! _chromeExtensionApi ){
				_chromeExtensionApi = new ChromeExtensionApi(config);
			}
			return _chromeExtensionApi;
			
		}
	
	
	};

	return rv;

}();